import { z } from 'zod';

// Tender pipeline stages, mirrors the legacy HTML app's Kanban columns.
export const TENDER_STAGES = [
  'lead',
  'invited',
  'estimating',
  'submitted',
  'shortlisted',
  'won',
  'lost',
  'withdrawn',
] as const;
export type TenderStage = (typeof TENDER_STAGES)[number];

export const TenderStageSchema = z.enum(TENDER_STAGES);

export const TENDER_STAGE_LABELS: Record<TenderStage, string> = {
  lead: 'Lead',
  invited: 'Invited',
  estimating: 'Estimating',
  submitted: 'Submitted',
  shortlisted: 'Shortlisted',
  won: 'Won',
  lost: 'Lost',
  withdrawn: 'Withdrawn',
};

// Stages considered "active" — counted in workload, shown in default pipeline.
export const ACTIVE_TENDER_STAGES: readonly TenderStage[] = [
  'lead', 'invited', 'estimating', 'submitted', 'shortlisted',
];

// Stages considered "closed" — excluded from workload calculations.
export const CLOSED_TENDER_STAGES: readonly TenderStage[] = ['won', 'lost', 'withdrawn'];

// ----------------------------------------------------------------------------

export const RFI_STATUSES = ['open', 'answered', 'closed', 'cancelled'] as const;
export type RfiStatus = (typeof RFI_STATUSES)[number];
export const RfiStatusSchema = z.enum(RFI_STATUSES);

// ----------------------------------------------------------------------------

export const QUOTE_STATUSES = [
  'draft',
  'sent',
  'accepted',
  'declined',
  'expired',
  'revised',
] as const;
export type QuoteStatus = (typeof QUOTE_STATUSES)[number];
export const QuoteStatusSchema = z.enum(QUOTE_STATUSES);

// ----------------------------------------------------------------------------

export const SITE_VISIT_STATUSES = ['scheduled', 'completed', 'cancelled', 'no_show'] as const;
export type SiteVisitStatus = (typeof SITE_VISIT_STATUSES)[number];
export const SiteVisitStatusSchema = z.enum(SITE_VISIT_STATUSES);
